import { http } from 'src/utils/http.util'
import { EHRDelay, THRCampaign, THRCampaignDispatch, THRCreateCampaignRequest, THRSmsLog } from 'src/types/hr'

export const HRCampaignService = {
  getCampaigns: async (projectId: number): Promise<THRCampaign[]> =>
    http.get(`/projects/${projectId}/hr/campaigns`).then((res) => res.data),

  getCampaign: async (projectId: number, campaignId: number): Promise<THRCampaign> =>
    http.get(`/projects/${projectId}/hr/campaigns/${campaignId}`).then((res) => res.data),

  createCampaign: async (projectId: number, data: THRCreateCampaignRequest): Promise<THRCampaign> =>
    http.post(`/projects/${projectId}/hr/campaigns`, data).then((res) => res.data),

  getDispatches: async (projectId: number, campaignId: number): Promise<THRCampaignDispatch[]> =>
    http.get(`/projects/${projectId}/hr/campaigns/${campaignId}/dispatches`).then((res) => res.data),

  getSmsLogs: async (projectId: number, campaignId: number, dispatchId: number): Promise<THRSmsLog[]> =>
    http
      .get(`/projects/${projectId}/hr/campaigns/${campaignId}/dispatches/${dispatchId}/sms-logs`)
      .then((res) => res.data),

  updateDispatch: async (
    projectId: number,
    campaignId: number,
    dispatchId: number,
    data: { delay: Exclude<EHRDelay, EHRDelay.PENDING_REVIEW> },
  ): Promise<THRCampaignDispatch> =>
    http
      .patch(`/projects/${projectId}/hr/campaigns/${campaignId}/dispatches/${dispatchId}`, data)
      .then((res) => res.data),
}
